import React, {Component} from 'react';
import MySQLStatsBox from "./MySQLStatsBox";
import MongoDBStatsBox from "./MongoDBStatsBox";
import ConfigBox from "./ConfigBox";

class SystemOverview extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                <i className="px-nav-icon ion-settings"/> Для разработчиков /
                                </span> Сводный обзор
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <MySQLStatsBox />
                    </div>
                    <div className="col-lg-6">
                        <MongoDBStatsBox />
                    </div>
                </div>
                <div className="row box-examples">
                    <div className="col-md-4">
                        <ConfigBox />
                    </div>
                    <div className="col-md-4">
                    </div>
                    <div className="col-md-4">
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">

                    </div>
                </div>
            </div>
        );
    }
}

export default SystemOverview;


// WEBPACK FOOTER //
// ./src/pages/Developers/SystemOverview/SystemOverview.js